'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopSettingsResponseModel = function ShopSettingsResponseModel(settings) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ShopSettingsResponseModel);

    this.channelId = settings.id;
    this.profileId = settings.profile_id;

    if (settings.seo) {
        this.seoSlug = settings.seo.slug;
        this.seoTitle = settings.seo.title;
        this.seoH1 = settings.seo.h1;
        this.seoDescription = settings.seo.description;
        this.seoKeywords = settings.seo.keywords;
        this.seoSemanticUrl = settings.seo.semantic_url;
        this.seoIndexation = settings.seo.indexation;
    }

    if (settings.currency) {
        this.currency = settings.currency;
    }

    if (settings.additionalFieldSettings) {
        this.additionalFieldSettings = settings.additionalFieldSettings;
    }

    if (settings.onlineShop) {
        this.shopName = settings.onlineShop.name;
        this.shopId = settings.onlineShop.id;
        this.shopIsOpen = !!settings.onlineShop.is_open;
        this.shopWorkSuspended = !!settings.onlineShop.work_suspended;
        this.onlineAdvisorCode = settings.onlineShop.online_advisor_code ? settings.onlineShop.online_advisor_code : '';
        this.googleAnalyticsCode = settings.onlineShop.google_analytics_code ? settings.onlineShop.google_analytics_code : '';
        this.yandexMetrikaCode = settings.onlineShop.yandex_metrika_code ? settings.onlineShop.yandex_metrika_code : '';
        this.pipoOnlineShopId = settings.onlineShop.pipo_online_shop_id;
        this.rootCategory = settings.onlineShop.root_category;
        this.orderInOneClick = settings.onlineShop.order_in_one_click;
        this.googleTagManagerHead = settings.onlineShop.google_tag_manager_head ? settings.onlineShop.google_tag_manager_head : '';
        this.googleTagManagerBody = settings.onlineShop.google_tag_manager_body ? settings.onlineShop.google_tag_manager_body : '';
        var contacts = JSON.parse(settings.onlineShop.contacts);
        if (contacts.cartButtons === undefined) {
            contacts.cartButtons = {
                buttonName: 'В корзину',
                buttonOneClickName: 'Купить в один клик'
            };
        }
        this.addBasketButtonName = contacts.cartButtons.buttonName ? contacts.cartButtons.buttonName : 'В корзину';
        this.addBasketButtonOneClickName = contacts.cartButtons.buttonOneClickName ? contacts.cartButtons.buttonOneClickName : 'Купить в один клик';
        if (contacts.customFields === undefined) {
            contacts.customFields = [];
        }
        this.customFields = contacts.customFields;
        this.buyInCreditActive = false;
        this.buyInCredit = {};
        if (settings.onlineShop.buyInCredit) {
            this.buyInCreditActive = settings.onlineShop.buyInCredit.enable;
            this.buyInCredit = settings.onlineShop.buyInCredit;
        }
        this.googleCaptcha = settings.onlineShop.google_captcha;
        this.googleCaptchaSitekey = settings.onlineShop.google_captcha_sitekey ? settings.onlineShop.google_captcha_sitekey : '';
        this.turnstileCaptcha = settings.onlineShop.turnstile_captcha;
        this.turnstileCaptchaSitekey = settings.onlineShop.turnstile_captcha_sitekey ? settings.onlineShop.turnstile_captcha_sitekey : '';
    }

    if (settings.onlineShopContent) {
        this.logo = settings.onlineShopContent.logo;
        this.logoPreview = settings.onlineShopContent.logo_preview;
        this.favicon = settings.onlineShopContent.favicon;
        this.faviconPreview = settings.onlineShopContent.favicon_preview;
        this.phoneShow = settings.onlineShopContent.phone_show;
        this.phone = settings.onlineShopContent.phone;
        this.operationModeShow = settings.onlineShopContent.operation_mode_show;
        this.operationMode = settings.onlineShopContent.operation_mode;
        this.basementText = settings.onlineShopContent.basement_text;
        this.slider_novelty = settings.onlineShopContent.slider_novelty;
        this.slider_hits = settings.onlineShopContent.slider_hits;
        this.slider_popular = settings.onlineShopContent.slider_popular;
        this.slider_category = settings.onlineShopContent.slider_category;
        this.themeColorId = parseInt(settings.onlineShopContent.theme_color_id) || 1;
        this.theme = (0, _utils.getCurrentThemeByColorId)(this.themeColorId);
        this.cartDescription = settings.onlineShopContent.cart_description;
        this.cartSubject = settings.onlineShopContent.cart_subject;

        this.deliveryFieldShow = !!settings.onlineShopContent.delivery_field_show; // показ textarea при создании заказа
        this.commentFieldShow = !!settings.onlineShopContent.comment_field_show; // показ textarea при создании заказа
        this.commentFieldTitle = settings.onlineShopContent.comment_field_title; // показ название textarea при создании заказа
        this.commentFieldPlaceholder = settings.onlineShopContent.comment_field_placeholder; // показ placeholder textarea при создании заказа
    }

    if (settings.onlineShopPages) {
        this.onlineShopPages = settings.onlineShopPages;
        if (this.buyInCreditActive) {
            this.onlineShopPages.forEach(function (page) {
                if (page.id === _this.buyInCredit.page_id) {
                    _this.buyInCredit.page = page.url_pages;
                }
            });
        }
    }
    this.loyaltySettingsActive = false;
    if (settings.loyaltySettings) {
        this.loyaltySettingsActive = settings.loyaltySettings.active;
        this.loyaltySettingsData = settings.loyaltySettings.settingsForShop;
    }
    if (settings.use_ibonus_loyalty !== true) {
        this.loyaltySettingsActive = false;
    }
};

exports.default = ShopSettingsResponseModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/Models/lib/ShopSettingsResponse.js
// module id = 1588
// module chunks = 0